import { createMuiTheme } from '@material-ui/core';

export const MUI_THEME = createMuiTheme({
    spacing: 5,
    palette: {
        primary: {
            light: '#F2F7FF',
            main: '#1E53A3',
            dark: '#223C64',
            contrastText: '#8AA9D8',
        },
        secondary: {
            main: '#009878',
        },
        success: {
            main: '#4CAF50',
        },
        text: {
            primary: '#464646',
            secondary: '#8AA9D8',
            disabled: '#b0b0b0',
        },
        grey: {
            50: '#F2F2F2',
            100: '#F5F6F7',
            200: '#A0A0A0',
            900: '#313131',
        },
        background: {
            default: '#F5F6F7',
            paper: '#FFFFFF',
        },
        action: {
            active: '#EE8422',
            hover: '#D46E10',
            disabled: '#E3E3E3',
            disabledBackground: '#000000',
        },
        divider: '#DBE4F2',
    },
    typography: {
        fontFamily: 'Orgon, sans-serif',
        h1: {
            fontSize: '1.875rem',
            fontWeight: 800,
        },
        h2: {
            fontSize: '1.75rem',
            fontWeight: 800,
            marginBottom: '20px',
        },
        h3: {
            fontSize: '1.5rem',
            fontWeight: 800,
        },
        h4: {
            fontSize: '1.25rem',
            fontWeight: 700,
        },
        h5: {
            fontSize: '1.125rem',
            fontWeight: 700,
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 700,
        },
        body1: {
            fontSize: '1rem',
        },
        body2: {
            fontSize: '1.125rem',
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1280,
            xl: 1920,
        },
    },
});
